define('modules/form_editor/views/editor_custom_linlogin',['require','exports','module','base/view','ldsh!../templates/editor_custom_linlogin'],function(require,exports,module){
  "use strict";
  var BaseView = require("base/view");

  var LinkedInLoginButtonEditorView = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_linlogin"),
    events: {
      "change .js-lin-app-id": "updateModel",
      "change .js-lin-button-size": "updateSize",
      "change .js-lin-button-position": "updatePosition"
    },
    updateModel: function(e){
      e.preventDefault();
      this.model.set("appId", this.$(".js-lin-app-id").val());
    },
    updateSize: function(e){
      e.preventDefault();
      var size = this.$(".js-lin-button-size option:selected").val();
      this.model.set("size", size);
    },
    updatePosition: function(e){
      e.preventDefault();
      var position = this.$(".js-lin-button-position option:selected").val();
      this.model.set("position", position);
    },
    onRender: function(){
      var size = this.model.get("size"),
          position = this.model.get("position");
      this.$(".js-lin-button-size option[value='" + size + "']").attr("selected", true);
      this.$(".js-lin-button-position option[value='" + position + "']").attr("selected", true);
      this.$el.i18n();
    }
  });
  module.exports = LinkedInLoginButtonEditorView;
});

